import Immutable from 'immutable';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { parse as parseQuery } from 'hub-http/helpers/params';
import TwoFactorAuth from '../components/TwoFactorAuth';
import { close2faBackup, setup2fa, setup2faForLogin, selectMethod, confirmMethod, completeGoogleAuthRegistration, completeHubSpotApp, changeVerificationCodeAttempt, confirmVerificationCodeAttempt, completeSetup, cancelSetup, changeSMSNumber, confirmSMSNumber, requestTwoFactorAuthStatus, turnOffTwoFactorAuth, requestTwoFactorAuthGenerateBackupCodes, printedOrSavedBackupCodes, completeBackupCodes, redirectToSecondary2faSetup, setup2faFromNudge, fetchBackupCodes } from '../actions/TwoFactorAuthActions';
import { getBackupCodes, getBackupModalVisible, getBackupCodesCreatedAt, getBackupCodesLoading, getSetupStep, getStagedMethod, getMethodPrecedence, getQRCode, getVerificationCodeAttempt, getShouldBlockSetupProgress, getVerificationCodeAttemptFailed, getStagedSMSNumber, getPrimaryAuthMethod, getSecondaryAuthMethod, isSetupForLogin, getSetupForLoginAccountInfo, getSMSRegisterError, getShouldRenderGoogleAuthWarning, getShouldNotSetupOnLogin, getShouldSetupSecondaryAuthMethod, getShouldBlockVerifyButton, getStagedConfig, getCanModify2FASettings, getRedirectUrl, getShow2FANudge, getPrimaryAuthInfo, getUnusedBackupCodes } from '../selectors/twoFactorAuth';
import { getUserIdFromAuth, getEmailFromAuth } from '../selectors/AuthSelector';
import * as TwoFactorAuthSetupSteps from '../constants/TwoFactorAuthSetupSteps';
import * as TwoFactorAuthMethods from '../constants/TwoFactorAuthMethods';
import * as TwoFactorAuthPrecedenceTypes from '../constants/TwoFactorAuthPrecedenceTypes';
import GoogleAuthQRCode from '../records/GoogleAuthQRCode';
import TwoFactorAuthSMSErrors from '../constants/TwoFactorAuthSMSErrors';
import withPartials from '../lib/withPartials';
import { compose } from 'redux';
import { jsx as _jsx } from "react/jsx-runtime";
class TwoFactorAuthContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isNewUser: false
    };
    this.handleConfirmSetupStep = this.handleConfirmSetupStep.bind(this);
    this.handleKeyUp = this.handleKeyUp.bind(this);
  }
  componentDidMount() {
    const {
      search
    } = this.props.location;
    const query = parseQuery(search.substr(1));
    this.props.requestTwoFactorAuthStatus();
    if (query.setup2faForLogin) {
      if (document.referrer.includes('invite-user')) {
        this.setState({
          isNewUser: true
        });
      }
      this.props.setup2faForLogin(query.setup2faForLogin, query.loginRedirectUrl);
      this.props.history.replace(Object.assign({}, this.props.location, {
        search: null,
        query: null
      }));
    } else if (query.setup2faFromNudge) {
      this.props.setup2faFromNudge(query.setup2faFromNudge);
      this.props.history.replace(Object.assign({}, this.props.location, {
        search: null,
        query: null
      }));
    }
  }
  handleKeyUp(evt) {
    const {
      setupStep,
      shouldBlockSetupProgress
    } = this.props;
    if (evt.keyCode === 13 && !shouldBlockSetupProgress) {
      this.handleConfirmSetupStep(setupStep);
    }
  }
  handleConfirmSetupStep(step) {
    const {
      precedence,
      smsNumber,
      verificationCodeAttempt,
      stagedConfig
    } = this.props;
    switch (step) {
      case TwoFactorAuthSetupSteps.CHOOSE_METHOD:
        this.props.confirmSMSNumber(precedence, smsNumber);
        break;
      case TwoFactorAuthSetupSteps.REGISTER_HUBSPOT_WITH_GA:
        this.props.completeGoogleAuthRegistration();
        break;
      case TwoFactorAuthSetupSteps.REGISTER_WITH_HUBSPOT_APP:
        this.props.completeHubSpotApp();
        break;
      case TwoFactorAuthSetupSteps.VERIFY_GOOGLE_AUTHENTICATOR:
        this.props.confirmVerificationCodeAttempt(precedence, verificationCodeAttempt, stagedConfig);
        break;
      case TwoFactorAuthSetupSteps.REGISTER_SMS:
        this.props.confirmSMSNumber(precedence, smsNumber);
        break;
      case TwoFactorAuthSetupSteps.VERIFY_SMS:
        this.props.confirmVerificationCodeAttempt(precedence, verificationCodeAttempt, stagedConfig);
        break;
      case TwoFactorAuthSetupSteps.BACKUP_CODES:
        this.props.completeBackupCodes();
        break;

      // no default
    }
  }
  render() {
    const {
      backupCodes,
      backupModalVisible,
      backupCodesCreatedAt,
      backupCodesLoading,
      email,
      setupStep,
      stagedAuthMethod,
      qrCode,
      verificationCodeAttempt,
      precedence,
      smsNumber,
      primaryAuthMethod,
      secondaryAuthMethod,
      partial,
      setupForLogin,
      setupForLoginAccountInfo,
      registerSmsError,
      redirectUrl,
      show2FANudge,
      unusedBackupCodes
    } = this.props;
    return /*#__PURE__*/_jsx(TwoFactorAuth
    // @ts-expect-error ts-migrate(2322) FIXME: Type '{ backupCodes: any; backupModalVisible: bool... Remove this comment to see the full error message
    , {
      backupCodes: backupCodes,
      backupCodesCreatedAt: backupCodesCreatedAt,
      backupCodesLoading: backupCodesLoading,
      backupModalVisible: backupModalVisible,
      canModify: this.props.canModify,
      confirmMethod: this.props.confirmMethod,
      confirmSMSNumber: this.props.confirmSMSNumber,
      email: email,
      invalidVerificationCode: this.props.invalidVerificationCode,
      onCancelSetup: this.props.cancelSetup,
      onChangeSMSNumber: this.props.changeSMSNumber,
      onChangeVerificationCodeAttempt: partial(this.props.changeVerificationCodeAttempt, precedence),
      onClickBackup: this.props.fetchBackupCodes,
      onClickSetup: this.props.setup2fa,
      onCloseBackup: this.props.close2faBackup,
      onCompleteSetup: this.props.completeSetup,
      onConfirmSetupStep: this.handleConfirmSetupStep,
      onKeyUp: this.handleKeyUp,
      onRemoveTwoFactorAuth: this.props.turnOffTwoFactorAuth,
      onSelectMethod: this.props.selectMethod,
      precedence: this.props.precedence,
      primaryAuthInfo: this.props.primaryAuthInfo,
      primaryAuthMethod: primaryAuthMethod,
      printedOrSavedBackupCodes: this.props.printedOrSavedBackupCodes,
      qrCode: qrCode,
      redirectToSecondary2faSetup: this.props.redirectToSecondary2faSetup,
      redirectUrl: redirectUrl,
      registerSmsError: registerSmsError,
      requestTwoFactorAuthGenerateBackupCodes: this.props.requestTwoFactorAuthGenerateBackupCodes,
      resendSMSCode: partial(this.props.confirmSMSNumber, precedence, smsNumber),
      secondaryAuthMethod: secondaryAuthMethod,
      setupForLogin: setupForLogin,
      setupForLoginAccountInfo: setupForLoginAccountInfo,
      setupStep: setupStep,
      shouldBlockSetupProgress: this.props.shouldBlockSetupProgress,
      shouldBlockVerifyButton: this.props.shouldBlockVerifyButton,
      shouldNotSetupOnLogin: this.props.shouldNotSetupOnLogin,
      shouldRenderGoogleAuthWarning: this.props.shouldRenderGoogleAuthWarning,
      shouldSetupSecondaryAuthMethod: this.props.shouldSetupSecondaryAuthMethod,
      show2FANudge: show2FANudge,
      smsNumber: smsNumber,
      stagedAuthMethod: stagedAuthMethod,
      verificationCodeAttempt: verificationCodeAttempt,
      isNewUser: this.state.isNewUser,
      unusedBackupCodes: unusedBackupCodes,
      userId: this.props.userId
    });
  }
}
TwoFactorAuthContainer.propTypes = {
  // @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof List' is not assignable t... Remove this comment to see the full error message
  backupCodes: PropTypes.instanceOf(Immutable.List),
  backupCodesCreatedAt: PropTypes.number,
  backupCodesLoading: PropTypes.bool,
  backupModalVisible: PropTypes.bool,
  cancelSetup: PropTypes.func.isRequired,
  canModify: PropTypes.bool.isRequired,
  changeSMSNumber: PropTypes.func.isRequired,
  changeVerificationCodeAttempt: PropTypes.func.isRequired,
  close2faBackup: PropTypes.func.isRequired,
  completeBackupCodes: PropTypes.func.isRequired,
  completeGoogleAuthRegistration: PropTypes.func.isRequired,
  completeHubSpotApp: PropTypes.func.isRequired,
  completeSetup: PropTypes.func.isRequired,
  confirmMethod: PropTypes.func.isRequired,
  confirmSMSNumber: PropTypes.func.isRequired,
  confirmVerificationCodeAttempt: PropTypes.func.isRequired,
  email: PropTypes.string.isRequired,
  fetchBackupCodes: PropTypes.func.isRequired,
  invalidVerificationCode: PropTypes.bool.isRequired,
  location: PropTypes.object.isRequired,
  partial: PropTypes.func.isRequired,
  precedence: PropTypes.oneOf(Object.keys(TwoFactorAuthPrecedenceTypes)).isRequired,
  primaryAuthInfo: PropTypes.string,
  primaryAuthMethod: PropTypes.oneOf(Object.keys(TwoFactorAuthMethods)),
  printedOrSavedBackupCodes: PropTypes.func.isRequired,
  qrCode: PropTypes.instanceOf(GoogleAuthQRCode),
  redirectToSecondary2faSetup: PropTypes.func.isRequired,
  redirectUrl: PropTypes.string,
  registerSmsError: PropTypes.oneOf(Object.keys(TwoFactorAuthSMSErrors)),
  requestTwoFactorAuthGenerateBackupCodes: PropTypes.func.isRequired,
  requestTwoFactorAuthStatus: PropTypes.func.isRequired,
  secondaryAuthMethod: PropTypes.oneOf(Object.keys(TwoFactorAuthMethods)),
  selectMethod: PropTypes.func.isRequired,
  setup2fa: PropTypes.func.isRequired,
  setup2faForLogin: PropTypes.func.isRequired,
  setup2faFromNudge: PropTypes.func.isRequired,
  setupForLogin: PropTypes.bool.isRequired,
  setupForLoginAccountInfo: PropTypes.object,
  setupStep: PropTypes.oneOf(Object.keys(TwoFactorAuthSetupSteps)).isRequired,
  shouldBlockSetupProgress: PropTypes.bool.isRequired,
  shouldBlockVerifyButton: PropTypes.bool.isRequired,
  shouldNotSetupOnLogin: PropTypes.bool.isRequired,
  shouldRenderGoogleAuthWarning: PropTypes.bool.isRequired,
  shouldSetupSecondaryAuthMethod: PropTypes.bool.isRequired,
  show2FANudge: PropTypes.bool.isRequired,
  smsNumber: PropTypes.string.isRequired,
  stagedAuthMethod: PropTypes.oneOf(Object.keys(TwoFactorAuthMethods)).isRequired,
  stagedConfig: PropTypes.object,
  turnOffTwoFactorAuth: PropTypes.func.isRequired,
  verificationCodeAttempt: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  unusedBackupCodes: PropTypes.number.isRequired,
  userId: PropTypes.number.isRequired
};
function mapStateToProps(state) {
  return {
    backupCodes: getBackupCodes(state),
    backupCodesCreatedAt: getBackupCodesCreatedAt(state),
    backupCodesLoading: getBackupCodesLoading(state),
    backupModalVisible: getBackupModalVisible(state),
    canModify: getCanModify2FASettings(state),
    email: getEmailFromAuth(state),
    invalidVerificationCode: getVerificationCodeAttemptFailed(state),
    precedence: getMethodPrecedence(state),
    primaryAuthInfo: getPrimaryAuthInfo(state),
    primaryAuthMethod: getPrimaryAuthMethod(state),
    qrCode: getQRCode(state),
    redirectUrl: getRedirectUrl(state),
    registerSmsError: getSMSRegisterError(state),
    secondaryAuthMethod: getSecondaryAuthMethod(state),
    setupForLogin: isSetupForLogin(state),
    setupForLoginAccountInfo: getSetupForLoginAccountInfo(state),
    setupStep: getSetupStep(state),
    shouldBlockSetupProgress: getShouldBlockSetupProgress(state),
    shouldBlockVerifyButton: getShouldBlockVerifyButton(state),
    shouldNotSetupOnLogin: getShouldNotSetupOnLogin(state),
    shouldRenderGoogleAuthWarning: getShouldRenderGoogleAuthWarning(state),
    shouldSetupSecondaryAuthMethod: getShouldSetupSecondaryAuthMethod(state),
    show2FANudge: getShow2FANudge(state),
    smsNumber: getStagedSMSNumber(state),
    stagedAuthMethod: getStagedMethod(state),
    stagedConfig: getStagedConfig(state),
    verificationCodeAttempt: getVerificationCodeAttempt(state),
    unusedBackupCodes: getUnusedBackupCodes(state),
    userId: getUserIdFromAuth(state)
  };
}
export default compose(withPartials, withRouter, connect(mapStateToProps, {
  cancelSetup,
  changeSMSNumber,
  changeVerificationCodeAttempt,
  close2faBackup,
  completeBackupCodes,
  completeGoogleAuthRegistration,
  completeHubSpotApp,
  completeSetup,
  confirmMethod,
  confirmSMSNumber,
  confirmVerificationCodeAttempt,
  fetchBackupCodes,
  printedOrSavedBackupCodes,
  redirectToSecondary2faSetup,
  requestTwoFactorAuthGenerateBackupCodes,
  requestTwoFactorAuthStatus,
  selectMethod,
  setup2fa,
  setup2faForLogin,
  setup2faFromNudge,
  turnOffTwoFactorAuth
}))(TwoFactorAuthContainer);